<template>
  <div class="export-btns">
    <el-tooltip content="Descargar CSV" placement="top">
      <button class="dir-view-toggle export-btn-csv" @click="handleCsv">
        <svg
          width="15"
          height="15"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path
            d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
          />
          <polyline points="14 2 14 8 20 8" />
          <line x1="16" y1="13" x2="8" y2="13" />
          <line x1="16" y1="17" x2="8" y2="17" />
          <polyline points="10 9 9 9 8 9" />
        </svg>
        <span class="export-btn-label">CSV</span>
      </button>
    </el-tooltip>
    <el-tooltip content="Descargar Excel" placement="top">
      <button class="dir-view-toggle export-btn-excel" @click="handleExcel">
        <svg
          width="15"
          height="15"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path
            d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
          />
          <polyline points="14 2 14 8 20 8" />
          <line x1="8" y1="13" x2="16" y2="13" />
          <line x1="8" y1="17" x2="16" y2="17" />
          <line x1="10" y1="9" x2="14" y2="9" />
        </svg>
        <span class="export-btn-label">XLS</span>
      </button>
    </el-tooltip>
  </div>
</template>

<script>
import * as XLSX from "xlsx";
import { signingEventBus } from "@/services/signingEventBus";

export default {
  name: "ExportButtons",
  props: {
    data: { type: Array, default: () => [] },
    columns: { type: Array, required: true },
    filename: { type: String, default: "exportar" }
  },
  methods: {
    getRows() {
      return this.data.map(item => {
        const row = {};
        this.columns.forEach(col => {
          row[col.label] =
            col.value != null
              ? col.value(item)
              : item[col.field] != null
              ? item[col.field]
              : "";
        });
        return row;
      });
    },
    handleCsv() {
      const rows = this.getRows();
      if (!rows.length) {
        this.$message({
          type: "warning",
          message: "No hay datos para exportar"
        });
        return;
      }
      const id = `dl_${Date.now()}`;
      const displayName = `${this.filename}.csv`;
      signingEventBus.$emit("download:start", {
        id,
        filename: displayName,
        format: "CSV"
      });
      try {
        const headers = Object.keys(rows[0]);
        const csv = [
          headers.join(","),
          ...rows.map(r =>
            headers
              .map(
                h => `"${String(r[h] != null ? r[h] : "").replace(/"/g, '""')}"`
              )
              .join(",")
          )
        ].join("\r\n");
        const blob = new Blob(["\uFEFF" + csv], {
          type: "text/csv;charset=utf-8;"
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = displayName;
        a.click();
        URL.revokeObjectURL(url);
        signingEventBus.$emit("download:done", { id, filename: displayName });
      } catch (e) {
        signingEventBus.$emit("download:error", {
          id,
          message: "No se pudo generar el archivo"
        });
      }
    },
    handleExcel() {
      const rows = this.getRows();
      if (!rows.length) {
        this.$message({
          type: "warning",
          message: "No hay datos para exportar"
        });
        return;
      }
      const id = `dl_${Date.now()}`;
      const displayName = `${this.filename}.xlsx`;
      signingEventBus.$emit("download:start", {
        id,
        filename: displayName,
        format: "Excel"
      });
      try {
        const ws = XLSX.utils.json_to_sheet(rows);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Datos");
        XLSX.writeFile(wb, displayName);
        signingEventBus.$emit("download:done", { id, filename: displayName });
      } catch (e) {
        signingEventBus.$emit("download:error", {
          id,
          message: "No se pudo generar el archivo"
        });
      }
    }
  }
};
</script>

<style scoped>
.export-btns {
  display: flex;
  align-items: center;
  gap: 4px;
}
.export-btn-csv,
.export-btn-excel {
  display: flex;
  align-items: center;
  gap: 3px;
}
.export-btn-excel {
  color: #1d9e75;
}
.export-btn-label {
  font-size: 10px;
  font-weight: 600;
  line-height: 1;
}
</style>
